<template>
  <footer class="hw-footer">
    <div class="hw-container">
      <div class="hw-footer-grid">
        <div>
          <a class="hw-brand" href="javascript:void(0)" @click="go('#home')">
            <span class="hw-logo">
              <img src="@/assets/img/logo.png" alt="Hardwired" />
            </span>
            <span class="hw-brand-text">
              <strong>HARDWIRED</strong>
              <span>Digital Solutions</span>
            </span>
          </a>
          <p>
            Software à medida para empresas que precisam de produtos digitais com engenharia a sério.
          </p>
          <div class="hw-social">
            <a
              v-for="(icon, i) in icons"
              :key="i"
              :href="icon.link"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="icon.label"
            >
              <v-icon size="18">{{ icon.text }}</v-icon>
            </a>
          </div>
        </div>
        <div>
          <h4>Navegação</h4>
          <button @click="go('#home')">Início</button>
          <button @click="go('#services')">Serviços</button>
          <button @click="go('#about')">Sobre</button>
          <button @click="go('#mkgest')">MKGest</button>
          <button @click="go('#contact')">Contacto</button>
        </div>
        <div>
          <h4>Legal</h4>
          <router-link to="/terms-and-conditions">Termos e Condições</router-link>
          <router-link to="/privacy-policy">Política de Privacidade</router-link>
          <a href="mailto:hello@hardwired.pt">hello@hardwired.pt</a>
        </div>
      </div>
      <div class="hw-legal">
        <span>{{ year }} Hardwired Digital Solutions, Lda</span>
        <span>Vale de São Cosme, Portugal</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      icons: [
        {
          text: "mdi-facebook",
          link: "https://www.facebook.com/hardwired.ds",
          label: "Facebook",
        },
        {
          text: "mdi-linkedin",
          link: "https://www.linkedin.com/company/hardwired-ds/",
          label: "LinkedIn",
        },
        {
          text: "mdi-instagram",
          link: "https://www.instagram.com/hardwired.pt",
          label: "Instagram",
        },
      ],
    };
  },
  methods: {
    go(hash) {
      const scroll = () => {
        this.$nextTick(() => {
          this.$vuetify.goTo(hash, { offset: 12, duration: 450 });
        });
      };
      if (this.$route.path !== "/") {
        this.$router.push("/").then(scroll);
      } else {
        scroll();
      }
    },
  },
};
</script>
